import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getManageableNotifications = (params) => {
  return axiosClient
    .get("api/admin/notifications/global-notifications", { params })
    .then((r) => r.data);
};
